<template>
  <div class="user-info-list-wrapper">
    <van-cell-group
      v-for="(group, groupIndex) of links"
      class="links-group"
      :key="groupIndex"
    >
      <van-cell
        v-for="(item, index) of group"
        center
        size="large"
        :is-link="!item.notLink"
        :key="index"
        :title="item.title"
        :to="item.path"
        @click="item.action"
      >
        <template v-slot:icon>
          <van-icon
            size="20"
            class="icon"
            :name="item.icon"
            :color="item.color"
          />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-list-wrapper {
  margin-top: 16px;
  .links-group {
    &:not(:first-child) {
      margin-top: 8px;
    }
  }
  .icon {
    margin-right: 6px;
  }
}
</style>
